module.exports = __webpack_public_path__ + "static/media/industry_icon3.6044dea3.svg";